import React from 'react';
import './WhyUS_PageSection.css';
import { Link } from 'react-router-dom';

const sections = [
    {
        title: "World's largest range - 16 types of blinds",
        description: "We believe that innovation in blinds brings a new dimension and pleasure in the living space which enhances happiness in life by offering Light Control according to your need, mood and Privacy. We have the World's largest range of 16 Types of Blinds, 10 Operating Systems and 2000+ shade options to match and enhance your interior.",
        image: '/Assets/WhyusPage_Images/15-type-blind.webp',
        Link: '/products',
    },
    {
        title: "Light Control & Privacy",
        description: "For every interior two things are very necessary one is a perfect light control solution and second is provision to maintain privacy along with beauty of interior design. With amazing wide range of Callistus blinds, that provides options on design, texture, visibility and openness, one can have all the qualities in one basket.",
        image: '/Assets/WhyusPage_Images/TDBU-3.webp',
        Link: null,
    },
    {
        title: "Customise Blinds Solution for your Home and Office",
        description: "Callistus Blinds never compromise with the dreams of people. Hence we create customized blinds as per client's desires and Interior Design demands.",
        image: '/Assets/WhyusPage_Images/Skylight-Colby-1.webp',
        Link: null,
    },
    {
        title: "Technical Solutions for challenging architectural designed Windows",
        description: "Callistus Blinds have solution to all types of windows. We follow a solution based approached to any window treatment needs. Even for slant windows we have special solution.",
        image: '/Assets/WhyusPage_Images/big-hight.webp',
        Link: null,
    },
    {
        title: "10 Operating system for your comfort",
        description: "Callistus Window Fashion provides 10 unique operating systems in the blinds – Manual and Motorised both. These unique operating systems give the ultimate pleasure in getting perfect light control.",
        image: '/Assets/WhyusPage_Images/10-operating.webp',
        Link: null,
    },
    {
        title: "Smart Automation Systems – Experience the luxury with Light control",
        description: "Home automation is the new age demand. With home automation today user can control from switching off light to controlling Window blinds with a single touch of screen. With Home Automation devices we offer multiple options such as controlling the lights, Air conditioning, automated Window Blinds etc.",
        image: '/Assets/WhyusPage_Images/remote-together.webp',
        Link: null,
    },
    {
        title: "Dispatch commitment of 48 hours",
        description: "Callistus Blinds is ever committed to its dispatches. With 48 hours of Dispatch commitment, our clients experience the fastest delivery.",
        image: '/Assets/WhyusPage_Images/dispatch.webp',
        Link: null,
    },
    {
        title: "Child and Pet Safety",
        description: "Making window blinds safer for homes with infants and young children has always been a priority for Callistus. Simple cord free operation is aesthetically pleasing & safer for children and pets. Make your home decor safe for children and let them roam around freely.",
        image: '/Assets/WhyusPage_Images/child_friendly-why-callistus.webp',
        Link: null,
    },
];

// Wraps any digits found inside a heading (e.g. "16", "2000+", "48") in a
// span so they can be styled with a different font (Lato) than the rest of
// the heading text (which uses the site-wide heading font).
const renderTitleWithStyledNumbers = (title) => {
    const parts = title.split(/(\d+\+?)/g);
    return parts.map((part, i) =>
        /^\d+\+?$/.test(part) ? (
            <span className="why-num" key={i}>{part}</span>
        ) : (
            <React.Fragment key={i}>{part}</React.Fragment>
        )
    );
};

const WhyPageSection = () => {
    return (
        <div className="why-container">
            <h1 className="why-page-title">Why Callistus</h1>
            <div className="why-breadcrumb">
                <Link to="/">Home</Link> <span>&gt;</span> <span>Why Callistus</span>
            </div>
            <p className="sec-pera">Callistus is a multinational brand which is supported by entrepreneurs with vast experience in various countries for more than 25 years in the Window Covering Industry. Being the most Innovative, Quality Oriented and determined to give unparalleled service is our Motto. We have the largest range of Blinds in the world which are corresponded with the highest options of excellent Operating Systems. Enhancing your window furnishing with a huge array of complementing fabrics is our priority.</p>
            <div className="why-section">
                {sections.map((section, index) => (
                    <div
                        className={`why-row ${index % 2 !== 0 ? 'reverse' : ''}`}
                        key={index}
                    >
                        <div className="why-text">
                            <h2>{renderTitleWithStyledNumbers(section.title)}</h2>
                            <p>{section.description}</p>
                            {section.Link !== null && (<Link to={section.Link}>Learn More</Link>)}
                        </div>
                        <div className="why-image">
                            <img src={section.image} alt={section.title} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WhyPageSection;